import {
    useToggleArchiveStateCodeMutation,
    useCreateStateCodeMutation,
    useGetArchivedPaginatedStateCodesMutation,
    useGetPaginatedStateCodesMutation,
    useUpdateStateCodeMutation,
} from '@services/member/list/state-codes/state-codes.endpoints';
import { StateCode } from '@services/member/list/state-codes/state-codes.types';
import { useState, useMemo, useEffect } from 'react';
import { PaginationMetadata } from '@services/providers/cosem.types';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
export const useStateCodesPageVM = () => {
    const [totalStateCodes, setTotalStateCodes] = useState<number>(0);
    const [isArchived, setIsArchived] = useState<boolean>(false);
    const [needReload, setNeedReload] = useState<boolean>();
    const MySwal = withReactContent(Swal);

    const [
        updateStateCode,
        {
            isSuccess: isUpdateStateCodeSuccess
        }
    ] = useUpdateStateCodeMutation();

    const [
        toggleArchiveStateCode,
        {
            isSuccess: isToggleArchiveStateCodeSuccess
        }
    ] = useToggleArchiveStateCodeMutation();

    const [
        createStateCode,
        {
            isSuccess: isCreateStateCodeSuccess
        }
    ] = useCreateStateCodeMutation();



    const handleArchiveStateCodes = async (lines: StateCode[], archive: boolean) => {
        MySwal.fire({
            title:
                lines.length === 1
                    ? archive ? 'Êtes-vous sûr de vouloir archiver ce code état ?' : 'Êtes-vous sûr de vouloir désarchiver ce code état ?'
                    : archive ? 'Êtes-vous sûr de vouloir archiver ces codes états ?' : 'Êtes-vous sûr de vouloir désarchiver ces codes états ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#01539D',
            confirmButtonColor: '#01539D',
            confirmButtonText: archive ? 'Archiver' : 'Désarchiver',
            cancelButtonColor: '#FF5F46',
            cancelButtonText: 'Annuler'
        }).then(async (result) => {
            if (result.isConfirmed) {
                lines.forEach((line) => {
                    toggleArchiveStateCode({ id: line.id, archived: archive });
                });
            }
        });
    };

    useEffect(() => {
        if(isCreateStateCodeSuccess || isUpdateStateCodeSuccess || isToggleArchiveStateCodeSuccess) {
            setNeedReload((prev) => !prev);
        }
    }, [isCreateStateCodeSuccess, isUpdateStateCodeSuccess, isToggleArchiveStateCodeSuccess]);

  
    const mutationHook = useMemo(() => {
        return isArchived ? useGetArchivedPaginatedStateCodesMutation : useGetPaginatedStateCodesMutation;
    }, [isArchived]);

    useEffect(() => {
        setTotalStateCodes(0);
    }, [isArchived]);

    const handleMetadata = (metadata: PaginationMetadata) => {
        if (metadata && metadata.total !== undefined) {
            setTotalStateCodes(metadata.total);
        }
    };

    return {
        mutationHook,
        totalStateCodes,
        setTotalStateCodes,
        isArchived,
        handleMetadata,
        handleArchiveStateCodes,
        needReload,
        setIsArchived,
        updateStateCode,
        createStateCode,
        MySwal
    };
};
